import styled from 'styled-components'
import Button from 'react-bootstrap/Button';

const corSecundariaDefault = process.env.REACT_APP_COR_SECUNDARIA || '#3d6062';
const corHoverDefault = process.env.REACT_APP_COR_FUNDO_TABLE || '#24393a';
const corTextoDefault = process.env.REACT_APP_COR_TEXTO || '#000';

export const BotaoCustomizado = styled.button`
  color: ${props => props.theme?.corTexto || corTextoDefault};
  font-size: 20px;
  border: 30px;
  background-color: ${props => props.theme?.corSecundaria || corSecundariaDefault};
  border-radius: 8px;
  width: 100%;
  height: 50px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;

  ${props => props.disabled === false &&`
    &:hover {
      background-color: ${props => props.theme?.corFundoTable || corHoverDefault};
      color: ${props => props.theme?.corTexto || corTextoDefault};
    }
  `}

  ${props => props.disabled &&`
    opacity: 0.7
  `}

  @media (max-width: 576px) {
    font-size: 14px; 
    padding: 5px 15px; 
    width: 120%; 
    height: 45px; 
  }
`

export const ResponsiveButton = styled(Button).attrs({
  className: 'btn btn-sm',
})`
  padding: 0.25rem 0.5rem;
  min-width: 30px;
  font-size: 12px;
  transition: all 0.2s;
  margin: 0 2px; // Substitui margin-left por margem lateral

  // Icones dentro do botão
  svg {
    font-size: inherit;
  }

  // Breakpoints
  @media (max-width: 1600px) { 
    padding: 0.2rem 0.4rem;
    min-width: 26px;
    font-size: 11px;
  }

  @media (max-width: 1280px) {
    padding: 0.15rem 0.3rem;
    min-width: 22px;
    font-size: 10px;
  }

  @media (max-width: 768px) {
    padding: 0.1rem 0.2rem;
    min-width: 20px;
    font-size: 8px;
  }
`;